// @ts-ignore
import {mapResourceApi} from '@/api/mapResourceApi'
import { globalConfigDIC } from '@/js/globalConfigDIC'

const mapsearcharound = {
  gaodetabsList: [],
  queryCallBack: null,
  analysisGaodeMapAround(distance, lonlat, queryCallBack) {
    const _this = this
    _this.queryCallBack = queryCallBack
    const paramsArr = []
    _this.gaodetabsList = globalConfigDIC.facilityDic
    for (let i = 0; i < _this.gaodetabsList.length; i++) {
      _this.gaodetabsList[i].resultList = []
      if (!distance) {
        distance = _this.gaodetabsList[i].distance
      }
      const queryKey = _this.gaodetabsList[i].keywords
      const searchtypes = _this.gaodetabsList[i].searchtypes
      const params = {
        types: searchtypes,
        location: lonlat,
        radius: distance,
        offset: 50,
        keywords: queryKey,
        key: 'c00caf5e3aa6c4407a56262c07481b13'
      }
      paramsArr.push(params)
    }
    mapResourceApi.gaodeAroundSearch(paramsArr).then(res => {
      if (Array.isArray(res)) {
        const resultArray = []
        for (let i = 0; i < res.length; i++) {
          if (res[i].data && res[i].data.pois && res[i].data.pois.length > 0) {
            _this.gaodetabsList[i].resultList = []
            _this.gaodetabsList[i].resultList = res[i].data.pois
            resultArray.push(_this.gaodetabsList[i])
          }
        }
        if (_this.queryCallBack) {
          _this.queryCallBack(resultArray)
        }
      } else {
        _this.queryCallBack([])
      }
    })
  }
}

export {
  mapsearcharound
}
